<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card>
        <b-row>
          <b-col sm="6" md="3" xl="3">
            <b-form-group>
              <label for="start_date" class="fs-5 fw-semibold d-inline"> Fecha inicio </label>
              <flat-pickr id="start_date" v-model="startDate" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3" xl="3">
            <b-form-group>
              <label for="endDate" class="fs-5 fw-semibold d-inline"> Fecha Final </label>
              <flat-pickr id="endDate" v-model="endDate" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3" xl="3">
            <b-form-group label="Tienda Origen" label-for="storeOrigin">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="locals"
                label="name"
                :reduce="(locals) => locals.id"
                input-id="storeOrigin"
                v-model="local"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3" xl="3">
            <b-form-group label="Acciones" label-for="actions" class="text-05">
              <div class="d-flex justify-content-around" id="actions">
                <b-button @click.prevent="searchReport" class="w-100" id="search" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">
                  <span class="align-middle">Buscar</span>
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <!-- <ventas-filters /> -->
      <b-card no-body>
        <b-card-header>
          <div>
            <b-card-sub-title class="mb-25"> Total </b-card-sub-title>
            <b-card-title class="font-weight-bolder"> S/. {{ totalAmount }} </b-card-title>
          </div>
        </b-card-header>
        <b-card-body>
          <vue-apex-charts ref="chartVenta" type="line" height="350" :options="chartOptions" :series="series" />
          <b-table
            class="position-relative text-center mt-4"
            :hover="true"
            :items="records"
            responsive
            :fields="fields"
            show-empty
            empty-text="No existen"
            @sort-changed="sortChanged"
          >
            <!-- Column: Actions -->
            <template #cell(id)="{ item, field: { key }, index }">
              <span>{{index + 1}}</span>
            </template>
          </b-table>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { $themeColors } from '@themeConfig'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import ventasFilters from './ventasFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StoreService from '@/services/StoresService'
import ReportService from '@/services/ReportsService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  components: {
    VueApexCharts,
    flatPickr,
    ventasFilters,
    vSelect
  },
  data() {
    return {
      showLoading: false,
      date: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      totalAmount: 0.0,
      rangePicker: ['2019-05-01', '2019-05-10'],
      records: [
      ],
      fields: [
        { key: 'id', label: 'Nº', sortable: false },
        { key: 'dateConverted', label: 'Fecha', sortable: false },
        { key: 'qtyTotal', label: 'Monto de Ventas(S/.)', sortable: false },
      ],
      locals: [],
      local: null,
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc',
      series: [
        {
          data: []
        }
      ],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        // colors: $themeColors.info,
        plotOptions: {
          bar: {
            vertical: true,
            barHeight: '30%',
            distributed: true
            // endingShape: 'rounded',
          }
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          // opposite: isRtl,
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    async getData() {
      this.locals = []
      const resp = await StoreService.getStores('',this.$store)
      console.log('resp', resp)
      if (resp) {
        this.locals = resp.stores
        // this.locals.unshift({
        //   id: 0,
        //   name: 'Todos'
        // })
      }
      // for (let index = 0; index < this.records.length; index++) {
      //   const element = this.records[index]
      //   this.chartOptions.xaxis.categories[index] = element.tipoLocal
      //   this.series[0].data[index] = element.monto
      // }
      // this.$refs.chartVenta.updateOptions(this.chartOptions)
      // this.$refs.chartVenta.updateSeries(this.series)
    },
    async searchReport() {
      if (this.local != null) {
        this.records = []
        let url = '?store=' + this.local
        console.log('url', url)
        const respReport = await ReportService.reportVentas(url, this.$store)
        if (respReport.sellers.length != 0) {
          this.records = respReport.sellers
          for (let index = 0; index < respReport.sellers.length; index++) {
            const element = respReport.sellers[index];
            this.chartOptions.xaxis.categories[index] = element.dateConverted
            this.series[0].data[index] = element.qtyTotal
            this.totalAmount += element.qtyTotal
          }          
        } else{
          this.chartOptions.xaxis.categories = []
            this.series[0].data = []
            this.totalAmount = 0
        }
        this.$refs.chartVenta.updateOptions(this.chartOptions)
          this.$refs.chartVenta.updateSeries(this.series)
      }
    },
  }
}
</script>

<style lang="scss">
.bg-red {
  background-color: #b2a6a6;
  color: #fff;
}
.py-05 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.text-05 {
  font-size: 0.85rem;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
